import React from "react";
import { StationCard } from "./StationCard";
import { Skeleton } from "./ui/skeleton";

export const StationGrid = ({ stations, loading, emptyState }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="rounded-xl border border-border bg-surface p-4">
            <div className="flex gap-4">
              <Skeleton className="h-16 w-16 rounded-lg bg-surfaceHover" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-3/4 bg-surfaceHover" />
                <Skeleton className="h-3 w-1/2 bg-surfaceHover" />
                <Skeleton className="h-3 w-1/3 bg-surfaceHover" />
              </div>
            </div>
            <Skeleton className="mt-4 h-10 w-10 rounded-full bg-surfaceHover" />
          </div>
        ))}
      </div>
    );
  }

  if (!stations || stations.length === 0) {
    return emptyState || null;
  }

  return (
    <div
      data-testid="station-grid"
      className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
    >
      {stations.map((s, i) => (
        <StationCard key={s.stationuuid + i} station={s} index={i} />
      ))}
    </div>
  );
};
